import { http } from "./http";
import type { Establishment } from "../types/establishments";

// Venue pages.
export const establishmentsApi = {
  get: (slug: string) => http.get<Establishment>(`/establishments/${slug}`),
};
